import { Box, Paper } from '@mui/material';
import React from 'react';
import CardsSection from './CardsSection';
import GraphSections from './GraphSections';

const LeftSectionWrapper = ({ fromDate, toDate }) => {

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <CardsSection fromDate={fromDate} toDate={toDate} />
      <GraphSections />
    </Box>
  );
};

export default LeftSectionWrapper;
